<app-data-table mainTitle="Participante"
                singleTitle="Participante"
                routerPath="/participante-empresa"
                entityPath="/participanteempresa"
                [entity]="participanteEmpresa"
                [entityFilter]="entityFilter"
                [columns]="this['columns']"
                [controls]="this['controls']">
</app-data-table>
